import { Base } from "ui/Scripts/source/framework/base";
import { IUnitNode, UnitNode } from "../unit/unitNode";
import { IUnitPermissionUserGroup, UnitPermissionUserGroup } from "../userGroup/unitPermissionUserGroup";
import { TUnitPermission } from "../unit/unitPermission";

export interface ILogProperties {
    logSizeInDays: number;
    userGroups: IUnitPermissionUserGroup[];
    unitNode: IUnitNode;
    unitPermissions: TUnitPermission[];
}

export class LogProperties implements ILogProperties {
    logSizeInDays: number;
    userGroups: UnitPermissionUserGroup[];
    unitNode: UnitNode;
    unitPermissions: TUnitPermission[];

    constructor();
    constructor(obj: ILogProperties);
    constructor(obj?: any) {
        this.logSizeInDays = obj && obj.logSizeInDays || 0;
        this.userGroups = Base.getTypedArray(obj ? obj.userGroups : null, UnitPermissionUserGroup);
        this.unitNode = new UnitNode(obj && obj.unitNode ? obj.unitNode : null);
        this.unitPermissions = obj && obj.unitPermissions || [];
    }
}